import { BaseModel } from '../BaseModel/BaseModel';
import { RawUserRole, UserRoleEntity } from './Types';
import { UserRoleEnum, UserRoleType } from '@shared/Enums/UserRoleEnum';

export class UserRoleModel
    extends BaseModel<RawUserRole, UserRoleEntity>
    implements UserRoleEntity
{
    createdAt: string = new Date().toISOString();
    id: number = 0;
    role: UserRoleType = UserRoleEnum.CUSTOMER;
    updatedAt: string = new Date().toISOString();

    constructor(userRole?: RawUserRole) {
        super();
        if (userRole) {
            this.initialize(userRole);
        }
    }

    initialize(userRole: RawUserRole) {
        this.createdAt = userRole.created_at;
        this.id = userRole.id;
        this.updatedAt = userRole.updated_at;
        this.role = userRole.role;
    }

    parse(): RawUserRole {
        return {
            created_at: this.createdAt,
            id: this.id,
            updated_at: this.updatedAt,
            role: this.role,
        };
    }
}
